// extracted by mini-css-extract-plugin
export default {"root":"InviteUserModal_root__Y4zUW","container":"InviteUserModal_container__BHEh3"};